import { render, staticRenderFns } from "./Ocr.vue?vue&type=template&id=ae869cd6&scoped=true"
import script from "./Ocr.vue?vue&type=script&lang=js"
export * from "./Ocr.vue?vue&type=script&lang=js"
import style0 from "./Ocr.vue?vue&type=style&index=0&id=ae869cd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae869cd6",
  null
  
)

export default component.exports